"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import { useHydrated, useSupabaseUser } from "@utils/hooks";
import React, { useEffect } from "react";

export default function ClarityTracker() {
  const hydrated = useHydrated();
  const user = useSupabaseUser();

  useEffect(() => {
    if (hydrated && user?.app_metadata?.iticket_user_uid) {
      sendGTMEvent({
        event: "clarity",
        userUid: user.app_metadata.iticket_user_uid,
      });
    }
  }, [hydrated, user]);

  return <></>;
}
